import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e0a12c4")

_pushScopeId("data-v-3e0a12c4")
const _hoisted_1 = {
  id: "cari-stt",
  class: "w-full h-full bg-gray-100"
}
const _hoisted_2 = { class: "bg-white flex flex-col text-12px xxl:text-14px overflow-hidden relative w-full h-full" }
const _hoisted_3 = { class: "flex flex-col justify-between items-start z-20 relative" }
const _hoisted_4 = { class: "flex flex-row py-4 align-middle items-center justify-between w-full px-8" }
const _hoisted_5 = { class: "font-semibold text-20px mr-4 text-black-lp-200 title-layout flex flex-row align-middle justify-center" }
const _hoisted_6 = {
  class: "mr-8",
  style: {"align-self":"center"}
}
const _hoisted_7 = { class: "p-3 bg-gray-100 h-full" }
const _hoisted_8 = {
  key: 0,
  class: "bg-white p-4 rounded-xl min-h-full h-full"
}
const _hoisted_9 = {
  key: 1,
  class: "bg-white p-4 rounded-xl min-h-full h-full"
}
const _hoisted_10 = { class: "flex flex-row mb-4" }
const _hoisted_11 = { class: "hidden" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Search = _resolveComponent("Search")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Print = _resolveComponent("Print")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: ["w-full border-t border-gray-lp-400", _ctx.isSidebarAndBreadcrumbV2 ? '' : 'mt-3']
        }, null, 2),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("cariStt.pageTitle")), 1)
          ]),
          _createVNode(_component_lp_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/cari-stt/scan'))),
            id: "btn-search-stt-list-stt",
            title: _ctx.$t('cariStt.scanButton'),
            textColor: "white"
          }, null, 8, ["title"])
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        (!_ctx.cariSTTList.length && !_ctx.params.search && !_ctx.params.startDate && !_ctx.params.endDate)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode(_component_EmptyState, {
                icon: "noData_empty",
                customHeaderMessage: _ctx.$t('cariStt.emptyState'),
                customMessage: _ctx.$t('cariStt.emptyStateDescription')
              }, null, 8, ["customHeaderMessage", "customMessage"])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_Search, {
                  class: "w-64 self-center",
                  onInput: _ctx.onSearch,
                  onClear: _ctx.clearSearch,
                  value: _ctx.searchValue,
                  placeholder: _ctx.$t('cariStt.searchPlaceholder'),
                  minChar: 1,
                  timeout: 1000
                }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
                _createVNode(_component_time_range_picker, {
                  startDate: _ctx.periodeStart,
                  endDate: _ctx.periodeEnd,
                  maxDate: new Date(),
                  isSetMaxDate: "",
                  onSelect: _ctx.setPeriode
                }, null, 8, ["startDate", "endDate", "maxDate", "onSelect"])
              ]),
              (_ctx.cariSTTList.length)
                ? (_openBlock(), _createBlock(_component_TableV2, {
                    key: 0,
                    columns: _ctx.columns,
                    data: _ctx.cariSTTList,
                    "border-bottom": false,
                    "border-top": false,
                    isSpaceTop: false,
                    isSpaceBottom: true,
                    "bg-header": "bg-white border-b border-t !rounded-none custom-header",
                    "custom-class-pagination": "absolute bottom-2 left-3 right-3 flex items-center px-4",
                    loading: _ctx.isLoadingFetch,
                    pagination: _ctx.pagination,
                    "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => (_ctx.pagination = $event)),
                    onRequest: _ctx.getListCariSTT,
                    onClick: _ctx.goToDetail,
                    errorCause: _ctx.errorCause,
                    onTryAgain: _ctx.getListCariSTT,
                    "pagination-style": "v3"
                  }, null, 8, ["columns", "data", "loading", "pagination", "onRequest", "onClick", "errorCause", "onTryAgain"]))
                : (_openBlock(), _createBlock(_component_EmptyState, {
                    key: 1,
                    icon: "ill_spot_search",
                    customHeaderMessage: _ctx.$t('cariStt.searchNotFound'),
                    customMessage: _ctx.$t('cariStt.searchNotFoundDescription')
                  }, null, 8, ["customHeaderMessage", "customMessage"]))
            ]))
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode(_component_Print, { ref: "print" }, null, 512)
    ])
  ]))
})